import React from "react";
import { H2, Paragraph } from "@singlestore/fusion/components/typography";
import { cx } from "class-variance-authority";

import { Link } from "components/Link/Link";

import { HeaderInfo } from "utils/parse-headers";

import "./OnThisPage.scss";

type PageMenuProps = {
    className?: string;
    headerChildren: Array<HeaderInfo>;
};

function PageMenu({ className, headerChildren }: PageMenuProps) {
    if (headerChildren.length === 0) {
        return null;
    }

    return (
        <ul className={className}>
            {headerChildren.map((child) => (
                <li key={child.id}>
                    <Paragraph variant="body-2">
                        <Link
                            to={`#${child.id}`}
                            type="secondary"
                            className="on-this-page-link"
                        >
                            {child.title}
                        </Link>
                    </Paragraph>
                    <PageMenu
                        headerChildren={child.children}
                        className="on-this-page-submenu"
                    />
                </li>
            ))}
        </ul>
    );
}

type OnThisPageProps = {
    className?: string;
    headers: HeaderInfo;
};

export function OnThisPage({ className, headers }: OnThisPageProps) {
    const classes = cx("on-this-page-section", className);

    if (headers.children.length === 0) {
        return null;
    }

    return (
        <div className={classes}>
            <H2
                variant="heading-1"
                color="mid-contrast"
                mb="1-5x"
                textTransform="uppercase"
            >
                On this page
            </H2>

            <PageMenu
                headerChildren={headers.children}
                className="on-this-page-menu"
            />
        </div>
    );
}
